module.exports = __webpack_public_path__ + "r-v3/img/ml_58_00.96e6acdd.jpg";